import { Component, Input, OnInit } from '@angular/core';
import { Order } from 'src/app/services/API.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements OnInit {

  @Input() order: Order;
  
  constructor() { }

  ngOnInit(): void {
  }

}
